module.exports = __webpack_public_path__ + "static/media/srelection.721b85ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tron/srelection.jpg
// module id = 1609
// module chunks = 0